import { defineStore } from 'pinia'

import * as api from '@/api/api'
import { upsertById } from '@/utils/utils'

import {
  ReportInstanceRead,
  ReportInstanceWrite,
  ReportScheduleRead,
  ReportScheduleWrite,
} from '@generated/types'

export interface ReportState {
  reports: ReportInstanceRead[]
  reportSchedules: ReportScheduleRead[]
}

export const useReportStore = defineStore({
  id: 'report',
  state: (): ReportState => {
    return {
      reports: [],
      reportSchedules: [],
    }
  },
  getters: {
    initialEmailRecipients: state => {
      return state.reportSchedules[0]?.recipients || []
    },
  },
  actions: {
    storeReport(rawReport: ReportInstanceRead): void {
      upsertById(rawReport, this.reports)
    },
    async getReports(): Promise<void> {
      const response = await api.getReportInstances()
      response.data.map(this.storeReport)
    },
    async createReport(report: ReportInstanceWrite): Promise<void> {
      const response = await api.createReportInstance(report)
      this.storeReport(response.data)
    },
    async getSalesReport(): Promise<void> {
      const response = await api.listReportSchedules()
      this.reportSchedules = response.data
    },
    async updateSalesReport(reportSchedule: ReportScheduleWrite): Promise<void> {
      const response = await api.updateReportSchedule(reportSchedule)
      upsertById(response.data, this.reportSchedules)
    },
    async createSalesReport(reportSchedule: ReportScheduleWrite): Promise<void> {
      const response = await api.createReportSchedule(reportSchedule)
      upsertById(response.data, this.reportSchedules)
    },
  },
})
